//Mactrix file added
/**
 * @public
 */
const DataTypes = {
	MANIFEST:	'MANIFEST',	//.m3u8 files
	CHUNK:		'CHUNK',	//.ts files
	KEY:		'KEY',		//AES key files
};

export default DataTypes;



// WEBPACK FOOTER //
// ./src/hlsjs/data-types.js